import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Field } from "@/types/interfaces/field";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormFields',
  props: {
	fields: {
		type: Array as PropType<Field[]>,
		required: true,
	},
},
  setup(__props) {



/* const validationErrors = inject(ValidationErrorsKey);

const getFieldValidationErrors = (field: Field) => {
	return validationErrors?.value.filter((r) => r.propertyName == field.id) || [];
}; */

const isFieldInvalid = (field: Field) => {
	// console.log("field :>> ", field);
	/* let state: null | true | false = null;
	if (getFieldValidationErrors(field).length > 0) {
		state = true;
	}
	return state; */
	return false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "before"),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.fields, (field) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        _renderSlot(_ctx.$slots, field.id + '_before', {
          field: field,
          isInvalid: isFieldInvalid(field)
        }),
        _renderSlot(_ctx.$slots, field.id, {
          field: field,
          isInvalid: isFieldInvalid(field)
        }),
        _renderSlot(_ctx.$slots, field.id + '_after', {
          field: field,
          isInvalid: isFieldInvalid(field)
        })
      ], 64))
    }), 256)),
    _renderSlot(_ctx.$slots, "after")
  ], 64))
}
}

})